import React from "react";

const SigninPage = () => {
	return (
		<div className="container mx-auto pt-8 pb-24 md:px-0 px-6 lg:w-1/3 w-full ">
			<form action=""></form>
			<h1> This is sign in</h1>
		</div>
	);
};

export default SigninPage;
